<template>
    <v-menu
        v-if="filter"
        offset-y
        content-class = "white"
        v-model       = "showMenu"
        :close-on-content-click="false"
        min-width="300"
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <div
                        class="header-button"
                    >
                        <a
                            class  = "dialog-button"
                            v-bind = "attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon color="white" size="22">mdi-filter-menu</v-icon>
                        </a>
                    </div>
                </template>
                <span>Anzeige enschränken</span>
            </v-tooltip>
        </template>

        <v-card class="pa-3">
            <v-row class="no-frame mb-0 lm-border pa-3 pt-4" style="height: 90px">
                <v-col class="no-frame">
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-switch
                                label="Aktuelle Gewähleistungen"
                                v-model  = "filter.current"
                                hide-details
                                class="mt-0"
                                @change="onChange"
                                :ripple="false"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-switch
                                label="Abgelaufene Gewähleistungen"
                                v-model  = "filter.past"
                                hide-details
                                class="mt-0"
                                @change="onChange"
                                :ripple="false"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>

</template>

<script>

export default {
    name: "IncWarrantyFilter",

    props: {
        value: {
            required: true,
            type: Object
        },
    },

    data: () => ({
        filter: null,
        showMenu : false,
    }),

    mounted() {
        this.filter = this.value;
    },

    methods: {
        onChange () {
            this.$emit("input", this.filter);
        }
    }
}
</script>

<style scoped>

.header-button {
    width: 30px;
    padding-top: 0;
}


</style>